export interface TourContent {
  id: string;
  createdAt: string;
  updatedAt: string;
  isDeleted: boolean;
  language: string;
  title: string;
  content: string;
  shortContent: string;
}

export interface AdditionServiceList {
  id: string;
  price: number;
}

export interface VisitPlaceList {
  id: string;
  price: number;
}

export interface TourPricing {
  id: string;
  type: string;
  tourType?: string; // or TourType enum if applicable, but string in json
  duration?: number;
  defaultPrice?: number;
  minPassengers?: number;
  pricePerPassenger?: number;
  status?: string;
  name?: string;
}
export interface ContentTourPriceOption {
  title?: string;
  shortContent?: string;
}

export interface VisitPlaceContent {
  id?: string;
  name?: string;
  description?: string;
  shortDescription?: string;
}

export interface VisitPlacesTourPriceOption {
  id?: string;
  thumbnailImage?: string;
  images?: string;
  contents?: VisitPlaceContent[];
}

export interface TourPriceOption {
  id: string;
  createdAt: string;
  updatedAt: string;
  isDeleted: boolean;
  tourId: string;
  duration: number;
  minPrice: number;
  defaultPrice: number;
  pricePassenger: number;
  tourPricing?: TourPricing;
  contents?: ContentTourPriceOption[];
  visitPlaces?: VisitPlacesTourPriceOption[];
}

export enum TourType {
  ADVENTURES = 'adventures',
  EXPERIENCE = 'experience',
}

export interface Tour {
  id: string;
  slug: string;
  images: string[];
  imageDetails: TourImageDetail[];
  minPrice: number;
  tourType: TourType;
  reserveTime?: number;
  passengerLimit: number;
  startActiveTime?: number;
  endActiveTime?: number;
  tourContents: TourContent[];
  tourPriceOptions: TourPriceOption[];
  pickUp?: string;
  pickUpAddress?: string;
  thumbnailImage: string;
  tourPriceOptionId?: string;
}

export interface TourDetail extends Tour {
  tourServices: TourAdditionalService[];
}

export interface TourAdditionalService {
  id: string;
  createdBy: string | null;
  updatedBy: string | null;
  createdAt: Date;
  updatedAt: Date;
  isDeleted: boolean;
  language: string;
  name: string;
  price: number;
  slot: number;
}

export interface TourImageDetail {
  uid?: string;
  alt?: string;
  url?: string;
}
